module.exports = __webpack_public_path__ + "img/bigdata.2c308c55.jpg";